import Swal from "sweetalert2";
import { addCache, getCache, updateCache } from "./localAche.js";
export default function globalFun(vue) {
  //提醒
  vue.prototype.info = function(message) {
    Swal.fire({
      title: message,
      icon: "info",
      showCloseButton: false,
    });
  };

  //成功提示
  vue.prototype.success = function(message) {
    Swal.fire({
      title: message,
      icon: "success",
      showCloseButton: false,
      showConfirmButton: false,
      timer: 1000,
    });
  };

  //失败提示
  vue.prototype.warning = function(message) {
    Swal.fire({
      title: message,
      icon: "error",
      showCloseButton: false,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  vue.prototype.confirm = function(message, fun, fun2) {
    Swal.fire({
      title: message,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#f46a6a",
      cancelButtonColor: "#74788d",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    }).then((result) => {
      if (result.value) {
        fun();
      } else {
        if (typeof fun2 == "function") {
          fun2();
        }
      }
    });
  };

  // 清空对象值为''、null、undefined、{}、[]的属性
  vue.prototype.cleanObj = function(obj) {
    for (var i in obj) {
      if (
        obj[i] === "" ||
        obj[i] === null ||
        obj[i] === undefined ||
        JSON.stringify(obj[i]) === "{}" ||
        JSON.stringify(obj[i]) === "[]"
      ) {
        delete obj[i];
      }
    }
  };
  //确认审核状态
  vue.prototype.preStatus = function(obj) {
    if (obj === 0) {
      return "审核草稿";
    }
    if (obj === 1) {
      return "通过";
    }
    if (obj === 2) {
      return "驳回";
    }
    if (obj === 3) {
      return "待审核";
    }
  };
  //确认类型
  vue.prototype.contentType = function(str) {
    if (obj === "video") {
      return "视频";
    }
    if (obj === "article") {
      return "文章";
    }
    if (obj === "carouse") {
      return "话题";
    }
    if (obj === "subject") {
      return "主题";
    }
  };
  vue.prototype.another = function(data) {
    if (typeof data == "object") {
      return JSON.parse(JSON.stringify(data));
    }
  };
  //判断内容上架时间 未到或者已过期   ture 为过期或上架时间 发布时间未到
  vue.prototype.isOverdue = function(start, end, state) {
    if (!start && !end && typeof state == "number") {
      return state == 1 ? false : true;
    }
    const now = new Date().getTime();
    const startDate = Date.parse(start);
    const endDate = Date.parse(end);

    if (start && end && typeof state == "number") {
      if (now >= startDate && now <= endDate && state === 1) {
        return false;
      } else {
        return true;
      }
    } else {
      if (!state && typeof state != "number") {
        return startDate > now ? true : false;
      }
      if (now > startDate && state === 1) {
        return false;
      } else {
        return true;
      }
    }
  };
  //秒转xx时xx分xx秒
  vue.prototype.secondsToHMS = function(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    if (hours === 0 && minutes === 0) {
      return `${remainingSeconds}秒`;
    } else if (hours === 0) {
      return `${minutes}分${remainingSeconds}秒`;
    } else {
      return `${hours}小时${minutes}分${remainingSeconds}秒`;
    }
  };

  //数据缓存，需要保持type参数唯一性
  vue.prototype.addCache = addCache;
  vue.prototype.getCache = getCache;
  vue.prototype.updateCache=updateCache;
}
